// extracted by mini-css-extract-plugin
module.exports = {"text":"input-message_text__2Hcu-","textError":"input-message_textError__1BxJC","textDescription":"input-message_textDescription__3wtux"};